import React, { useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { useField } from '@unform/core';
import { ThemeContext } from 'styled-components';
import Avatar from 'components/Avatar';

import {
  Container,
  SelectComponent,
  customStyles,
  menuHeaderStyle,
  ErrorMessage,
  OptionContent,
  OptionComercial,
  Flag,
} from './styles';

export default function AsyncSelect({
  name,
  errorField,
  searchable,
  type,
  menuPlacement,
  ...rest
}) {
  const selectAsyncRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  const themeContext = useContext(ThemeContext);
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectAsyncRef.current,
      path: 'select.state.value',
      getValue: ref => {
        if (rest.isMulti) {
          if (!ref.select.state.value) {
            return [];
          }
          return ref.select.state.value.map(option => option.value);
        } else {
          if (!ref.select.state.value) {
            return '';
          }
          return ref.select.state.value.value;
        }
      },
      // setValue: (ref, value) => {
      //   ref.select.select.setValue(value)
      // },
      clearValue(ref) {
        ref.select.select.setValue();
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  const MenuList = props => {
    return (
      <components.MenuList {...props}>
        {!props.isLoading && (
          <div style={menuHeaderStyle}>Digite pelo menos 3 caracteres</div>
        )}
        {props.children}
      </components.MenuList>
    );
  };

  const OptionAvatar = props => {
    return (
      <OptionContent>
        <Avatar
          size="36"
          name={props.data.label}
          src={props.data.avatar_url}
          round
        />

        <components.Option {...props} />
      </OptionContent>
    );
  };

  const OptionFiltroChamada = props => {
    return (
      <OptionContent>
        <Flag type={props.data.status || null} />
        <components.Option {...props} />
      </OptionContent>
    );
  };

  const formatOptionLabel = ({ label, created_at }) => (
    <OptionComercial>
      <div>{label}</div>
      <span>{created_at}</span>
    </OptionComercial>
  );

  const defaultOption = props => {
    return <components.Option {...props} />;
  };

  let customOption;
  switch (type) {
    case 'avatar':
      customOption = OptionAvatar;
      break;
    case 'filtroChamada':
      customOption = OptionFiltroChamada;
      break;
    default:
      customOption = defaultOption;
      break;
  }

  return (
    <Container error={errorField}>
      <SelectComponent
        error={error}
        styles={customStyles(themeContext)}
        isSearchable={searchable}
        ref={selectAsyncRef}
        classNamePrefix="react-select2"
        cacheOptions
        menuPlacement={menuPlacement}
        defaultOptions
        defaultValue={defaultValue}
        formatOptionLabel={formatOptionLabel}
        formatCreateLabel={inputValue => `Criar novo " ${inputValue} "`}
        noOptionsMessage={() => 'Sem opções'}
        components={{ MenuList, Option: customOption }}
        loadingMessage={() => 'Carregando ...'}
        {...rest}
      />

      {!!errorField && <ErrorMessage>{error || errorField}</ErrorMessage>}
    </Container>
  );
}

AsyncSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  searchable: PropTypes.bool,
  multiple: PropTypes.bool,
  errorField: PropTypes.string,
  isLoading: PropTypes.bool,
  menuPlacement: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  handleSelected: PropTypes.func,
  children: PropTypes.object,
  data: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
    }).isRequired,
  ),
};
